export const environment = {
  production: true,
  buildId: '3571023388922621',
  configFile: 'config.json',
};
